// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "analytics.proto" (package "kalos.analytics.v1", syntax proto3)
// tslint:disable
import { AnalyticsService } from "./analytics";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * Analytics Service - Domain-Driven Architecture with 4 Main Tabs
 *
 * @generated from protobuf service kalos.analytics.v1.AnalyticsService
 */
export class AnalyticsServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = AnalyticsService.typeName;
        this.methods = AnalyticsService.methods;
        this.options = AnalyticsService.options;
    }
    /**
     * Financial Performance Tab - Comprehensive financial metrics with department/job type drilldowns
     *
     * @generated from protobuf rpc: GetFinancialPerformanceMetrics
     */
    getFinancialPerformanceMetrics(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Pricing & Job Profitability Tab - Pricing metrics with department/job type drilldowns
     *
     * @generated from protobuf rpc: GetPricingMetrics
     */
    getPricingMetrics(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Job Profitability List - Paginated and searchable job profitability table
     *
     * @generated from protobuf rpc: GetJobProfitability
     */
    getJobProfitability(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Service Quality Tab - Service quality metrics with department/job type drilldowns
     *
     * @generated from protobuf rpc: GetServiceQualityMetrics
     */
    getServiceQualityMetrics(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Technician Callback Analysis - Detailed callback metrics per technician
     *
     * @generated from protobuf rpc: GetTechnicianCallbackAnalysis
     */
    getTechnicianCallbackAnalysis(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Technician Performance Tab - Technician metrics with department aggregations
     *
     * @generated from protobuf rpc: GetTechnicianPerformance
     */
    getTechnicianPerformance(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Technician Performance Detail - Comprehensive detail view for a single technician
     *
     * @generated from protobuf rpc: GetTechnicianPerformanceDetail
     */
    getTechnicianPerformanceDetail(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Job Status Tab - Blocked jobs attention queue
     *
     * @generated from protobuf rpc: GetBlockedJobs
     */
    getBlockedJobs(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Job Status Tab - Status breakdown grouped by department or job type
     *
     * @generated from protobuf rpc: GetJobStatusBreakdown
     */
    getJobStatusBreakdown(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Job Status Tab - Aggregated KPI metrics for job progress
     *
     * @generated from protobuf rpc: GetJobProgressKPIs
     */
    getJobProgressKPIs(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Accounts Overview - per-customer financial metrics for account managers
     *
     * @generated from protobuf rpc: GetCustomerAccountsOverview
     */
    getCustomerAccountsOverview(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Callback Events List - paginated event-level callback records so the
     * frontend can drill into a callback tile and group/filter by disposition.
     *
     * @generated from protobuf rpc: ListCallbackEvents
     */
    listCallbackEvents(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Pricing sell sheets drill-down: same row population as VolumeOfSalesSheets
     * on GetPricingMetrics (sell_sheets_view + active event + standard filter).
     *
     * @generated from protobuf rpc: ListPricingSellSheets
     */
    listPricingSellSheets(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Membership Sales - KPIs, per-seller and per-plan breakdowns, monthly trend
     * and renewal outlook for the Membership Sales page.
     *
     * @generated from protobuf rpc: GetMembershipSalesMetrics
     */
    getMembershipSalesMetrics(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Membership Sales - paginated per-sale rows behind the KPI and breakdown
     * drill-downs, filtered exactly like the metrics RPC.
     *
     * @generated from protobuf rpc: ListMembershipSales
     */
    listMembershipSales(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
